import * as $ from 'jquery';
export default function serializeJSON(element: HTMLElement): any {
  return $(element).serializeJSON({useIntKeysAsArrayIndex: false});
}
